<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 position-fixed background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto">
            <div class="fs-main text-center color-white">Grazing patterns</div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar mt-5">
        <div class="p-5 d-flex justify-content-center">
            <ngb-datepicker #dp
                            (dateSelect)="onDateSelection($event)"
                            [classList]="'justify-content-center'"
                            [dayTemplate]="t"
                            [displayMonths]="1"
                            [maxDate]="today"
                            [startDate]="today"
                            class="row d-flex justify-content-center align-items-center"
                            outsideDays="hidden"></ngb-datepicker>
            <ng-template #t let-date>
                <span (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null"
                    [class.faded]="(isInSelectedRange(date) || isInHoveredRange(date)) && isValidRange()"
                    [class.range]="isStartOrEndOfRange(date)"
                    class="custom-day">
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
        @if (!heatmapShown) {
            <div class="row ps-3 pe-3 pb-3">
                <app-generic-button
                    (click)="generateHeatmap()"
                    description="Load grazing pattern"
                    [alwaysShowText]="true"
                    [buttonText]="'Search'"
                    [disabled]="loading || heatmapShown || !fromDate"
                    [loading]="loading"
                    [primaryIcon]="'fa fa-magnifying-glass'"/>
            </div>
        }
        @if (heatmapShown) {
            <div class="row ps-3 pe-3 pb-3">
                <app-generic-button
                    (click)="reset()"
                    description="Clear grazing pattern"
                    [alwaysShowText]="true"
                    [buttonText]="'Reset'"
                    [disabled]="loading || !heatmapShown"
                    [loading]="loading"
                    [primaryIcon]="'fa fa-recycle'"/>
            </div>
        }
    </div>
</div>